import { Components, Theme } from '@mui/material';

export const MuiSlider: Components<Omit<Theme, 'components'>>['MuiSlider'] = {
  styleOverrides: {
    root: ({ theme }) => ({
      // Styling the rail (inactive part)
      '& .MuiSlider-rail': {
        opacity: 1,
        backgroundColor: theme.palette.primary.onColorFixedDim,
        height: '12px',
      },
      // Styling the track (active part)
      '& .MuiSlider-track': {
        backgroundColor: theme.palette.primary.onColorFixedVar,
        border: 'none',
        height: '12px',
      },
      // Styling the thumb (knob)
      '& .MuiSlider-thumb': {
        height: '20px',
        width: '20px',
        backgroundColor: '#D9D9D9',
      },
      // Styling the mark (dots)
      '& .MuiSlider-mark': {
        backgroundColor: theme.palette.primary.onColorFixedVar,
        height: '6px',
        width: '6px',
        borderRadius: '50%',
      },
      '& .MuiSlider-valueLabelOpen': {
        backgroundColor: theme.palette.inverse.surface,
        borderRadius: '4px',
        fontSize: '12px',
        lineHeight: '16px',
        letterSpacing: '0.4px',
        fontWeight: 400,
        color: theme.palette.inverse.onSurface,
        padding: '4px 8px',
        '&:before': {
          display: 'none',
        },
      },
    }),
  },
};
